import React from "react";
import {
  Person as PersonIcon,
  ShoppingBag as BagIcon,
  Favorite as WishlistIcon,
  ShoppingCart as OrdersIcon,
  SupportAgent as SupportAgentIcon,
} from "@mui/icons-material";
import { FaDollarSign } from "react-icons/fa";

export const getProfileMenuItems = ({
  navigate,
  openAppRedirect,
}) => [
  {
    key: "profile",
    label: "Profile",
    icon: <PersonIcon />,
    path: "/profile",
    onClick: () => navigate("/profile"),
  },
  {
    key: "booking",
    label: "Booking Request",
    icon: <BagIcon />,
    path: "/Booking",
    onClick: () => navigate("/Booking"),
  },
  {
    key: "orders",
    label: "My Orders",
    icon: <OrdersIcon />,
    path: "/orders",
    onClick: () => navigate("/orders"),
  },
  {
    key: "wishlist",
    label: "Wishlist",
    icon: <WishlistIcon />,
    path: "/wishlist",
    onClick: () => navigate("/wishlist"),
  },
  {
    key: "earning",
    label: "Earnings",
    icon: <FaDollarSign />,
    path: "/earnings",
    onClick: () => navigate("/earnings"),
  },
  {
    key: "support",
    label: "Help & Support",
    icon: <SupportAgentIcon />,
    path: "/contact-us",
    onClick: () => navigate("/contact-us"),
  },
];